import React, { useEffect, useRef, useState } from "react";
import {Spin} from 'antd';
import { NFTItemIcon } from "../Icons/NFTItemIcon";
import { useApp } from "../../contexts";
import { useWindowSize } from "../../hook/useWindowSize";
import {LoadingOutlined} from '@ant-design/icons';

export const ImageCustom = (props) => {
  const imageInnerRef = useRef(null);
  const { isShowNft, isShowFullscreen, isShowSub, isShowFree } = props;
  const imageRef = useRef(null);
  const { T } = useApp();
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const handleReady = () => {
    setLoaded(true);
  };
  const size = useWindowSize();
  const isMobile = size.width < 768
  const toggleFullscreen = () => {
    if (!isMobile) {
      if (!document.fullscreenElement && !document.webkitFullscreenElement) {
        if (imageInnerRef.current.requestFullscreen) {
          imageInnerRef.current.requestFullscreen().catch((err) => {
            console.error(`Error entering fullscreen: ${err.message}`);
          });
        } else if (imageInnerRef.current.webkitRequestFullscreen) { // For Safari
          imageInnerRef.current.webkitRequestFullscreen().catch((err) => {
            console.error(`Error entering fullscreen: ${err.message}`);
          });
        }
        if (imageInnerRef.current.webkitSupportsFullscreen) {
          imageInnerRef.current.webkitEnterFullscreen();
          return;
        }
  
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitExitFullscreen) { // For Safari
          document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      }
    }else{
      setIsFullscreen(!isFullscreen);
      if (!isFullscreen) {
        document.body.classList.add("overflow-hidden");
      } else {
        document.body.classList.remove("overflow-hidden");
      }
    }
  };
  useEffect(() => {
    const handleFullscreenChange = () => {
      setIsFullscreen(!!document.fullscreenElement);
    };

    document.addEventListener("fullscreenchange", handleFullscreenChange);
    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
    };
  }, []);

  return (
    <>
      <div
        className={`custom-image ${ isFullscreen ? "fullscreen" : ""}`}
        ref={imageInnerRef}
      >
        <img
          ref={imageRef}
          className={`loading-transition ${
            loaded ? "!opacity-100 !relative" : "!opacity-0 absolute"
          }`}
          src={props?.src}
          onLoad={handleReady}
          onContextMenu={(e) => e.preventDefault()}
          alt=""
        />
        {!loaded ? <div className={"w-full h-full"}>
          <img src='/assets/images/placeholder_thumbnail.gif' className='w-full object-contain' />
        </div>: <></>}
        {isShowNft || isShowFree || isShowSub ? (
          <div className="top-[15px] absolute left-3 flex justify-start gap-2 items-center ">
            {isShowSub ? (
              <div className="flex justify-start item-has-sub gap-[5px] text-[12px] lg:text-[20px] bg-[#E9A033] rounded-[100px] items-center text-white font-[500] px-3 lg:px-6 py-[6px] tag-boxshadow">
                <svg
                  width="15"
                  height="14"
                  viewBox="0 0 15 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.90725 0.301079L9.44059 4.84081L14.2315 4.89628C14.6438 4.90108 14.8145 5.42641 14.4838 5.67228L10.6401 8.53308L12.0678 13.1069C12.1905 13.5005 11.7441 13.8248 11.4075 13.5864L7.49925 10.8147L3.59045 13.5859C3.25445 13.8243 2.80752 13.4995 2.93018 13.1064L4.35792 8.53255L0.514184 5.67175C0.183518 5.42588 0.354184 4.90055 0.766451 4.89575L5.55738 4.84028L7.09072 0.300546C7.22298 -0.0898541 7.77552 -0.0898542 7.90725 0.301079Z"
                    fill="white"
                  />
                </svg>
                <div>{T("Art Plus")}</div>
              </div>
            ) : (
              <></>
            )}
            {isShowFree ? (
              <>
                <div className="flex justify-start items-center item-has-sub text-[12px] lg:text-[20px] space-x-1 bg-[#E5665B] rounded-[100px] text-white font-[500] px-3 lg:px-6 py-[8px] tag-boxshadow">
                  <svg
                    className="w-[20px] h-[20px] mt-[-4px]"
                    width="21"
                    height="21"
                    viewBox="0 0 21 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M5.11328 5.94043C5.34375 6.1709 5.71485 6.1709 5.94141 5.94043C6.16797 5.70996 6.17188 5.33887 5.94141 5.1123L4.28516 3.45605C4.05469 3.22559 3.6836 3.22559 3.45703 3.45605C3.23047 3.68652 3.22657 4.05762 3.45703 4.28418L5.11328 5.94043Z"
                      fill="white"
                    />
                    <path
                      d="M1.08594 11.0859H3.46875C3.79297 11.0859 4.05469 10.8242 4.05469 10.5C4.05469 10.1758 3.79297 9.91406 3.46875 9.91406H1.08594C0.761719 9.91406 0.5 10.1758 0.5 10.5C0.5 10.8242 0.761719 11.0859 1.08594 11.0859Z"
                      fill="white"
                    />
                    <path
                      d="M19.9141 9.91406H17.5312C17.207 9.91406 16.9453 10.1758 16.9453 10.5C16.9453 10.8242 17.207 11.0859 17.5312 11.0859H19.9141C20.2383 11.0859 20.5 10.8242 20.5 10.5C20.5 10.1758 20.2383 9.91406 19.9141 9.91406Z"
                      fill="white"
                    />
                    <path
                      d="M17.542 3.45605C17.3115 3.22559 16.9404 3.22559 16.7139 3.45605L15.0576 5.1123C14.8271 5.34277 14.8271 5.71387 15.0576 5.94043C15.2881 6.16699 15.6592 6.1709 15.8857 5.94043L17.542 4.28418C17.7725 4.05371 17.7725 3.68652 17.542 3.45605Z"
                      fill="white"
                    />
                    <path
                      d="M11.0859 3.46875V1.08594C11.0859 0.761719 10.8242 0.5 10.5 0.5C10.1758 0.5 9.91406 0.761719 9.91406 1.08594V3.46875C9.91406 3.79297 10.1758 4.05469 10.5 4.05469C10.8242 4.05469 11.0859 3.79297 11.0859 3.46875Z"
                      fill="white"
                    />
                    <path
                      d="M5.39026 9.16313C4.93323 11.0381 5.46058 12.9366 6.80823 14.2608C7.2887 14.7413 7.56995 15.4952 7.56995 16.2686V16.3975C7.56995 16.7256 7.82776 16.9834 8.15589 16.9834H12.8434C13.1715 16.9834 13.4293 16.7256 13.4293 16.3975V16.2686C13.4293 15.5069 13.7223 14.7295 14.2379 14.2256C15.2223 13.2295 15.7731 11.9053 15.7731 10.4991C15.7731 8.88188 15.0465 7.37016 13.7809 6.36235C12.5035 5.35453 10.8512 4.99125 9.23401 5.37797C7.35901 5.81157 5.84729 7.29985 5.39026 9.16313ZM10.4996 7.56938C10.8239 7.56938 11.0856 7.8311 11.0856 8.15532C11.0856 8.47953 10.8239 8.74125 10.4996 8.74125C9.61683 8.74125 8.97229 9.32719 8.80433 10.0069C8.7262 10.3155 8.41761 10.5108 8.09339 10.4366C7.78089 10.3584 7.58948 10.042 7.66761 9.72563C7.95667 8.55375 9.05823 7.56938 10.4996 7.56938Z"
                      fill="white"
                    />
                    <path
                      d="M11.0859 20.5C12.0547 20.5 12.8438 19.7109 12.8438 18.7422V18.1562H8.15625V18.7422C8.15625 19.7109 8.94531 20.5 9.91406 20.5H11.0859Z"
                      fill="white"
                    />
                  </svg>
                  <div>{T("Free")}</div>
                </div>
              </>
            ) : (
              <></>
            )}
            {isShowNft ? (
              <>
                <div>
                  <NFTItemIcon className="w-[40px] h-[40px]" />
                </div>
              </>
            ) : (
              <></>
            )}
          </div>
        ) : (
          <></>
        )}
        {isShowFullscreen ? (
          <>
            {!isFullscreen ? (
              <button onClick={toggleFullscreen} className="btn-image-action">
                <svg
                  width="12"
                  height="11"
                  viewBox="0 0 12 11"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7 4.5L11 0.5M11 0.5L8 0.5M11 0.5L11 3.5"
                    stroke="black"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M5 6.5L1 10.5M1 10.5L4 10.5M1 10.5L1 7.5"
                    stroke="black"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </button>
            ) : (
              <button onClick={toggleFullscreen} className="btn-image-action">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M19 1L11.8 8.2M11.8 8.2L17.2 8.2M11.8 8.2L11.8 2.8"
                    stroke="black"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M1 19L8.2 11.8M8.2 11.8L2.8 11.8M8.2 11.8L8.2 17.2"
                    stroke="black"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </button>
            )}
          </>
        ) : (
          <></>
        )}
      </div>
    </>
  );
};

export default ImageCustom;
